<template>
  <div>
    <div class="rate-chart">
      <div class="rate-pie" :id="'rate-pie-' + type"></div>
    </div>
  </div>
</template>

<script>
import Echarts from "echarts";
export default {
  name: "rateListPie",
  components: {},
  props: {
    echartsData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    color: {
      type: String,
      default: {
        return: ""
      }
    },
    type: {
      type: Number,
      default: {
        return: 0
      }
    }
  },
  data() {
    return {
      rateDialog: false,
      myChart: {},
      name: "",
      score: "",
      scoreClass: []
    };
  },
  created() {
    this.$nextTick(() => {
      this.loadEchart();
    });
  },
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    loadEchart() {
      let colors = [this.color, "#EDF0F7"];
      this.myChart = Echarts.init(
        document.getElementById("rate-pie-" + this.type)
      );
      let option = {
        title: {
          // text: "",
        },
        tooltip: {
          // show: false
          // trigger: "axis",
        },
        legend: {
          // type: 'scroll',
          show: false,
          orient: "vertical",
          bottom: "center",
          right: 0,
          top: "center",
          itemWidth: 12,
          itemHeight: 12,
          textStyle: {
            color: "#C4CDFF"
          }
          // data: []
        },
        grid: {
          top: "1%",
          left: "1%",
          right: "1%",
          bottom: "1%",
          containLabel: true
        },
        toolbox: {
          // feature: {
          //   saveAsImage: {},
          // },
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: ["100%", "80%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2
            },
            label: {
              show: false,
              position: "center"
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "40",
                fontWeight: "bold"
              }
            },
            labelLine: {
              show: false
            },
            data: [],
            silent: true
          }
        ],
        color: colors
      };
      let num = 0;
      switch (this.type) {
        case 1:
          num = this.echartsData.loginIntergral;
          break;
        case 2:
          num = this.echartsData.userinfoIntergral;
          break;
        case 3:
          num = this.echartsData.patrolIntergral;
          break;
        case 4:
          num = this.echartsData.dutyReportIntergral;
          break;
        case 5:
          num = this.echartsData.troubleIntergral;
          break;
        default:
          break;
      }
      // console.log(num, 23445);
      option.series[0].data = [
        {
          name: "",
          value: num || 0,
          itemStyle: {
            shadowColor: "rgba(0, 0, 0, 0.06)",
            shadowBlur: 4
          },
        },
        {
          name: "",
          value: this.echartsData.totalNum - num || 0
        }
      ];
      // option.legend.data = {
      //   name: "",
      //   value: this.echartsData.totalNum || 0
      // };
      // console.log(option.xAxis.data)
      // console.log(option.legend.data)

      this.myChart.setOption(option);
    }
  },
  destroyed() {}
};
</script>

<style lang="scss" scoped>
.rate-pie {
  width: 110px;
  height: 110px;
}
</style>
